import React, { useCallback } from "react";
import { Select } from "antd";
import ee from "../../../../services/EventEmitter";
import { CHANGE_CUSTOM_GROUP_FIELD } from "../../../../constants/events";
import {
  BELARUS_REGION,
  REGION_OPTIONS,
} from "../../../../calculators/clientsFeeCalculator";
import { SelectOption } from "../../../common/forms/Interfaces";

interface DestinationCustomsProps {
  groupId: number | string;
  defaultValue?: "belarus" | "others";
}

const options: SelectOption[] = [
  {
    label: "Belarus",
    value: BELARUS_REGION,
  },
  ...REGION_OPTIONS,
];

const DestinationCustoms: React.FC<DestinationCustomsProps> = ({
  groupId,
  defaultValue,
}) => {
  const onChangeHandler = useCallback(
    (value) => {
      ee.emit(CHANGE_CUSTOM_GROUP_FIELD, {
        entityId: groupId,
        entityKey: "customs_code_and_office_name",
        value: value || null,
      });
    },
    [groupId]
  );

  return (
    <Select
      placeholder="Select Destination Customs"
      className="table-select"
      options={options}
      onChange={onChangeHandler}
      defaultValue={defaultValue}
      size="small"
      allowClear
    />
  );
};

export default DestinationCustoms;
